"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return (vue_2.pushScopeId("data-v-58b983dd"), n = n(), vue_2.popScopeId(), n); };
var _hoisted_1 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "head" }, [
    /*#__PURE__*/ vue_2.createElementVNode("div", null, "Товар"),
    /*#__PURE__*/ vue_2.createElementVNode("div"),
    /*#__PURE__*/ vue_2.createElementVNode("div", null, "Цена"),
    /*#__PURE__*/ vue_2.createElementVNode("div", null, "Количество"),
    /*#__PURE__*/ vue_2.createElementVNode("div", null, "Сумма")
], -1); });
var _hoisted_2 = { class: "item" };
var _hoisted_3 = { class: "item__i" };
var _hoisted_4 = { class: "img" };
var _hoisted_5 = ["src", "alt"];
var _hoisted_6 = {
    key: 1,
    class: "termi-image"
};
var _hoisted_7 = { class: "item__content" };
var _hoisted_8 = { class: "description" };
var _hoisted_9 = { class: "code" };
var _hoisted_10 = ["href"];
var _hoisted_11 = { class: "item__bottom" };
var _hoisted_12 = { class: "price" };
var _hoisted_13 = { class: "summ" };
var _hoisted_14 = ["onClick"];
var _hoisted_15 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("i", { class: "termi-trashcan" }, null, -1); });
var _hoisted_16 = [
    _hoisted_15
];
var _hoisted_17 = {
    key: 1,
    class: "item"
};
var ItemCounter_vue_1 = require("./ItemCounter.vue");
var helpers_ts_1 = require("./helpers.ts");
exports.default = vue_1.defineComponent({
    props: {
        items: null,
        disabled: { type: Boolean },
        compact: { type: Boolean }
    },
    emits: ['removePosition', 'changePositionCount'],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        return function (_ctx, _cache) {
            return (vue_2.openBlock(), vue_2.createElementBlock("div", {
                class: vue_2.normalizeClass(["OrderPositionsTable", { 'compact': props.compact }])
            }, [
                (Array.isArray(props.items) && props.items.length)
                    ? (vue_2.openBlock(), vue_2.createElementBlock(vue_2.Fragment, { key: 0 }, [
                        _hoisted_1,
                        (vue_2.openBlock(true), vue_2.createElementBlock(vue_2.Fragment, null, vue_2.renderList(props.items, function (item, i) {
                            return (vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_2, [
                                vue_2.createElementVNode("div", _hoisted_3, vue_2.toDisplayString(i + 1), 1),
                                vue_2.createElementVNode("div", _hoisted_4, [
                                    (item.image)
                                        ? (vue_2.openBlock(), vue_2.createElementBlock("img", {
                                            key: 0,
                                            src: item.image,
                                            alt: item.title
                                        }, null, 8, _hoisted_5))
                                        : (vue_2.openBlock(), vue_2.createElementBlock("i", _hoisted_6))
                                ]),
                                vue_2.createElementVNode("div", _hoisted_7, [
                                    vue_2.createElementVNode("div", _hoisted_8, [
                                        vue_2.createElementVNode("div", _hoisted_9, "Код товара: " + vue_2.toDisplayString(item.code), 1),
                                        vue_2.createElementVNode("a", {
                                            href: item.url,
                                            class: "title"
                                        }, vue_2.toDisplayString(item.variant_title), 9, _hoisted_10)
                                    ]),
                                    vue_2.createElementVNode("div", _hoisted_11, [
                                        vue_2.createElementVNode("div", _hoisted_12, vue_2.toDisplayString(vue_2.unref(helpers_ts_1.priceStringFormat)(item.price)), 1),
                                        vue_2.createVNode(ItemCounter_vue_1.default, {
                                            amount: item.count,
                                            onUpdate: function (amount) { emit('changePositionCount', { amount: amount, position_id: item.id }); },
                                            disabled: props.disabled
                                        }, null, 8, ["amount", "onUpdate", "disabled"]),
                                        vue_2.createElementVNode("div", _hoisted_13, vue_2.toDisplayString(vue_2.unref(helpers_ts_1.priceStringFormat)(item.price * item.count)), 1)
                                    ])
                                ]),
                                (!__props.disabled)
                                    ? (vue_2.openBlock(), vue_2.createElementBlock("div", {
                                        key: 0,
                                        class: "trashcan",
                                        onClick: function ($event) { return (emit('removePosition', item.id)); }
                                    }, _hoisted_16, 8, _hoisted_14))
                                    : vue_2.createCommentVNode("", true)
                            ]));
                        }), 256))
                    ], 64))
                    : (vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_17, " Корзина пустая "))
            ], 2));
        };
    }
});
